import { ARROW_CLOSE_ENVELOPE } from 'constants/envelopeIcons';
import { TAG_ADD_ICON, TAG_REMOVE_ICON } from 'constants/filterIcons';
import React, { useState } from 'react';

type Set = {
  teamId: string;
  regionId: string;
  teamName: string;
  regionName: string;
  selected: boolean;
};

type ComponentProps = {
  sets: Set[];
  toggleSetSelection: (set: Set) => void;
};

const ReviewSetsCollapsableTeamSection: React.FC<ComponentProps> = ({
  sets,
  toggleSetSelection,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = (): void => {
    setIsOpen((b) => !b);
  };

  const handleToggleSelect = (set: Set): void => {
    toggleSetSelection(set);
  };

  return (
    <div className="flex flex-col gap-1">
      <div className="flex flex-row gap-1 items-center">
        <button type="button" className="flex focus:outline-none" onClick={handleOpen}>
          <span
            className={`focus:outline-none transition-transform duration-300 ${
              isOpen && 'transform rotate-90'
            }`}
          >
            {ARROW_CLOSE_ENVELOPE()}
          </span>
        </button>
        <span>{sets[0].teamName}</span>
      </div>
      {isOpen && (
        <div className="flex flex-row gap-1">
          {sets.map((set) => (
            <div
              key={`${set.teamId}-${set.regionId}`}
              className={`px-1 py-0.5 flex flex-row gap-1 rounded text-small ${
                set.selected ? 'bg-litlingo-success-light' : 'bg-litlingo-gray-0.5'
              }`}
            >
              <span>
                {set.regionName} ({set.teamName})
              </span>
              <button
                onClick={(e): void => {
                  e.stopPropagation();
                  handleToggleSelect(set);
                }}
                className="focus:outline-none outline-none"
                type="button"
              >
                {set.selected ? TAG_REMOVE_ICON : TAG_ADD_ICON}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ReviewSetsCollapsableTeamSection;
